import { Component, OnInit ,Input,Output,EventEmitter,SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-pagnationout',
  templateUrl: './pagnationout.component.html',
  styleUrls: ['./pagnationout.component.css']
})
export class PagnationoutComponent implements OnInit {
    @Input() data: any;
    @Output() callback: EventEmitter<any> = new EventEmitter();
    page_arr: Array<number> = [];
    page_count: number = 0;

    input_tmp_page: number = 0;
    constructor() { }

  ngOnInit(): void {
    this.wacth_page_arr();
    this.when_page_change(this.data.page);
  }

  ngOnChanges(changes: {[propKey: string]: SimpleChanges }) {
    this.when_page_change(this.data.page);
  }

  wacth_page_arr() {
    if (typeof(this.data.total_count) == 'undefined') return;
    if (this.data.count == 0) {
        this.page_arr = [];
    } else {
        this.page_count = Math.ceil(this.data.total_count / this.data.count);
        this.page_arr = [];

        let max_display = 5; // Maximum number of pages to display
        let start = Math.max(0, this.data.page - Math.floor(max_display / 2));
        let end = Math.min(this.page_count, start + max_display);

        // Adjust start if the end exceeds the page count
        if (end - start < max_display) {
            start = Math.max(0, end - max_display);
        }

        for (let i = start; i < end; i++) {
            this.page_arr.push(i);
        }
    }

    if (this.data.page > this.page_count - 1) {
        this.data.page = 0;
    }
  }

  click_page(page: number) {
    this.data.page = page;
    this.when_page_change(this.data.page);
  }

  pre_click_page() {
    if (this.data.page > 0) {
        this.data.page = this.data.page - 1;
        this.when_page_change(this.data.page);
    }
  }

  aft_click_page() {
    if (this.data.page < this.page_count - 1) {
        this.data.page = this.data.page + 1;
        this.when_page_change(this.data.page);
    }
  }

  when_page_change(value: number) {
    if (isNaN(value)) return;

    let page_start = this.data.page - 3;
    let page_end = this.data.page + 3;
    if (page_start < 0) {
        page_end -= page_start;
    }
    if (page_end > this.page_count) {
        page_start -= page_end - this.page_count;
    }
    if (this.data.page > this.page_count) {
        this.data.page = 0;
    }
    this.callback.emit(this.data);
    this.wacth_page_arr();
    this.input_tmp_page = this.data.page * 1 + 1;
  }

  getstyle(): any {
    const width = this.page_count.toString().length * 60;
    return { 'width': width + 'px', 'display': 'inline', ' margin-left': '5px', 'height': '36px' };
  }

  inputpage() {
    this.input_tmp_page = (this.input_tmp_page < 1) ? 1 : (this.input_tmp_page > this.page_count) ? this.page_count : this.input_tmp_page;
    this.data.page = this.input_tmp_page * 1 - 1;
    this.when_page_change(this.data.page);
  }

  isPrevDisabled(): boolean {
    return this.data.page === 0;
  }

  isNextDisabled(): boolean {
    return this.data.page === this.page_count - 1;
  }
}
